<template>
    <div>
        <home-detail :scene="scene">
            <template #main>
                <h1>ACTORS AND SPEAKERS</h1>
                <p>
                    Voicecasting is an ONLINE professional database with original audio samples and photos of actors and
                    speakers from many origins, nationalities, languages. Their numbers increases every month.
                </p>
                <p>
                    All voices / actors in the database are native speakers and are available for recording and
                    shooting. Listen to voice samples, choose from photos, create shortlists, sent them to your clients,
                    order actors for recording / shooting.
                </p>
                <br />
            </template>
            <!--     <template #right>
                <div block="buttons">
                    <nav-button :to="'/voice-database/demo1'" :text="'VOICE ADMIN DEMO'" :icon="'videocam'" size="big" radius="circle" />
                    <nav-button :to="'/voice-database/demo2'" :text="'VOICE ADMIN DEMO'" :icon="'videocam'" size="big" radius="circle" />
                </div>
                <nav-button v-if="scene == 'subpage'" :to="'/voice-database'" class="close" :icon="'close'" color="ghost" size="icon" />
            </template> -->
        </home-detail>
        <div block="subpage">
            <transition name="bottom">
                <router-view view="subpage"></router-view>
            </transition>
        </div>
    </div>
</template>
<script>
import HomeDetail from '@/components/Home/HomeDetail.vue';
import NavButton from '@/components/.global/NavButton.vue';
import Btn from '@/components/.global/Btn.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';
export default {
    name: 'About',

    props: {
        scene: {
            type: String,
            required: false,
        },
    },

    components: {
        HomeDetail,
        NavButton,
        Mp3Player,
        Btn,
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';
</style>
